import * as API_ROUTES from '../../routing/api';
import { requests } from '../../helper/agent';
import { userLogout } from './user';
import {
  CCSD_CHANGES_BULK_CHECK_ERROR,
  CCSD_CHANGES_BULK_CHECK_REQUEST,
  CCSD_CHANGES_BULK_CHECK_SUCCESS,
  CCSD_CHANGES_CHECK_ERROR,
  CCSD_CHANGES_CHECK_REQUEST,
  CCSD_CHANGES_CHECK_SUCCESS,
  CCSD_CHANGES_DELETE_ERROR,
  CCSD_CHANGES_DELETE_REQUEST,
  CCSD_CHANGES_DELETE_SUCCESS,
  CCSD_CHANGES_LIST_CLEAR_FILTERS,
  CCSD_CHANGES_LIST_ERROR,
  CCSD_CHANGES_LIST_REQUEST,
  CCSD_CHANGES_LIST_SET_FILTERS,
  CCSD_CHANGES_LIST_SET_PAGE,
  CCSD_CHANGES_LIST_UNLOAD,
  CCSD_CHANGES_LIST_UPDATED,
} from '../constants';

export const ccsdChangesListRequest = () => ({ type: CCSD_CHANGES_LIST_REQUEST });
export const ccsdChangesListUpdated = (data) => ({ type: CCSD_CHANGES_LIST_UPDATED, data });
export const ccsdChangesListError = (error) => ({ type: CCSD_CHANGES_LIST_ERROR, error });
export const ccsdChangesListUnload = () => ({ type: CCSD_CHANGES_LIST_UNLOAD });
export const ccsdChangesListSetPage = (page) => ({ type: CCSD_CHANGES_LIST_SET_PAGE, page });
export const ccsdChangesListSetFilters = (filters, routeKey) => ({ type: CCSD_CHANGES_LIST_SET_FILTERS, filters, routeKey });
export const ccsdChangesListClearFilters = (routeKey) => ({ type: CCSD_CHANGES_LIST_CLEAR_FILTERS, routeKey });

export const ccsdChangesListFetch = (page = 1, filters = {}) => {
  return (dispatch) => {
    dispatch(ccsdChangesListRequest());
    filters.page = page;
    return requests
      .get(API_ROUTES.DATED_COSTS, filters)
      .then((response) => dispatch(ccsdChangesListUpdated(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        }
        dispatch(ccsdChangesListError(error));
      });
  };
};

export const ccsdChangesCheck = (id) => {
  return (dispatch) => {
    dispatch({ type: CCSD_CHANGES_CHECK_REQUEST, id });
    return requests
      .post(API_ROUTES.DATED_COSTS_CHECK.replace(':id', id), {})
      .then((response) => {
        dispatch({ type: CCSD_CHANGES_CHECK_SUCCESS, data: response });
        return response;
      })
      .catch((error) => {
        dispatch({ type: CCSD_CHANGES_CHECK_ERROR, error });
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        }
        throw error;
      });
  };
};

export const ccsdChangesUncheck = (id) => {
  return (dispatch) => {
    dispatch({ type: CCSD_CHANGES_CHECK_REQUEST, id });
    return requests
      .post(API_ROUTES.DATED_COSTS_UNCHECK.replace(':id', id), {})
      .then((response) => {
        dispatch({ type: CCSD_CHANGES_CHECK_SUCCESS, data: response });
        return response;
      })
      .catch((error) => {
        dispatch({ type: CCSD_CHANGES_CHECK_ERROR, error });
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        }
        throw error;
      });
  };
};

export const ccsdChangesDelete = (id, page, filters) => {
  return (dispatch) => {
    dispatch({ type: CCSD_CHANGES_DELETE_REQUEST, id });
    return requests
      .delete(API_ROUTES.DATED_COSTS_SINGLE.replace(':id', id))
      .then((response) => {
        dispatch({ type: CCSD_CHANGES_DELETE_SUCCESS, id });
        // The row is hard deleted, so refetch rather than trying to patch it out of the page
        dispatch(ccsdChangesListFetch(page, { ...filters }));
        return response;
      })
      .catch((error) => {
        dispatch({ type: CCSD_CHANGES_DELETE_ERROR, error });
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        }
        throw error;
      });
  };
};

export const ccsdChangesBulkCheck = (ids, page, filters) => {
  return (dispatch) => {
    dispatch({ type: CCSD_CHANGES_BULK_CHECK_REQUEST });
    return requests
      .post(API_ROUTES.DATED_COSTS_BULK_CHECK, { ids })
      .then((response) => {
        dispatch({ type: CCSD_CHANGES_BULK_CHECK_SUCCESS });
        dispatch(ccsdChangesListFetch(page, { ...filters }));
        return response;
      })
      .catch((error) => {
        dispatch({ type: CCSD_CHANGES_BULK_CHECK_ERROR, error });
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        }
        throw error;
      });
  };
};
